import { Currency } from "@types";

/**
 * Currencies for which we prompt players to add a phone number after their
 * funding profile is complete (COP/PEN PGWs require real contact data).
 * Configurable: add a currency here to extend the feature.
 */
export const PHONE_COLLECTION_CURRENCIES: Currency[] = [Currency.COP, Currency.PEN];
